module.exports = __webpack_public_path__ + "static/img/0-2home.2fce5a8f.jpg";